// D6 Nylon 실측 데이터 파서
// docs/sample/8.17 nylon (D6~D10)/{TIC1.txt, MS1.txt} → Vite ?raw import
// Cotton과 차이: TAB-separated + .txt 확장자 + 26 scan blocks

import msTxt from "@/assets/real-data/d6-nylon-ms.txt?raw";
import ticTxt from "@/assets/real-data/d6-nylon-tic.txt?raw";
import type { MassSpectrumData, TICData } from "@/types/spectrum";
import type { MSScan } from "./parseD1Cotton";

// ─── TIC Parser ───────────────────────────────────────────────────────────────
// TIC1.txt format (TAB-separated, CRLF):
//   #"+EI TIC Scan Diesel_nilon1.D "
//   #Point\tX(Minutes)\tY(Counts)
//   0\t0.094\t0
//   ...

export const d6NylonTIC: TICData[] = (() => {
  const lines = ticTxt.split(/\r?\n/);
  const data: TICData[] = [];
  for (const line of lines) {
    if (line.startsWith("#") || line.trim() === "") continue;
    const parts = line.split("\t");
    if (parts.length < 3) continue;
    const rt = parseFloat(parts[1].trim());
    const intensity = parseFloat(parts[2].trim());
    if (!Number.isNaN(rt) && !Number.isNaN(intensity)) {
      data.push({ rt, intensity });
    }
  }
  return data;
})();

// ─── MS Parser ────────────────────────────────────────────────────────────────
// MS1.txt format (TAB-separated, CRLF):
//   #"+EI Scan (rt: 1.513 min) Diesel_nilon1.D "
//   #Point\tX(Thomsons)\tY(Counts)
//   0\t38.9\t159.08
//   ...
// 26 scan blocks (cotton: 16)

export const d6NylonMSScans: MSScan[] = (() => {
  const scans: MSScan[] = [];
  const lines = msTxt.split(/\r?\n/);
  let currentRT: number | null = null;
  let currentData: MassSpectrumData[] = [];

  for (const line of lines) {
    const rtMatch = line.match(/EI Scan \(rt: ([\d.]+) min\)/);
    if (rtMatch) {
      if (currentRT !== null && currentData.length > 0) {
        scans.push({ rt: currentRT, data: currentData });
      }
      currentRT = parseFloat(rtMatch[1]);
      currentData = [];
    } else if (line.startsWith("#") || line.trim() === "") {
    } else if (currentRT !== null) {
      const parts = line.split("\t");
      if (parts.length < 3) continue;
      const mz = parseFloat(parts[1].trim());
      const intensity = parseFloat(parts[2].trim());
      if (!Number.isNaN(mz) && !Number.isNaN(intensity)) {
        currentData.push({ mz, intensity });
      }
    }
  }
  // Flush last scan
  if (currentRT !== null && currentData.length > 0) {
    scans.push({ rt: currentRT, data: currentData });
  }
  return scans;
})();

// ─── Helper: nearest scan ─────────────────────────────────────────────────────

/**
 * 클릭 RT에 가장 가까운 Nylon D6 실측 MS 스캔을 반환한다.
 * TIC 임의 RT 클릭 → 26개 실측 스캔 중 nearest 반환.
 */
export function getNearestNylonScan(rt: number): MSScan | null {
  if (d6NylonMSScans.length === 0) return null;
  return d6NylonMSScans.reduce((prev, cur) =>
    Math.abs(cur.rt - rt) < Math.abs(prev.rt - rt) ? cur : prev,
  );
}
